export default {
  gewerbe: {
    hero: {
      eyebrow: 'Klientë biznesi',
      title: 'Vëzhgim profesional me video për nevoja biznesi',
      lead: 'Nga dega e shitjes me pakicë te salla e prodhimit – planifikojmë, instalojmë dhe mirëmbajmë sisteme kamerash në shërbim të biznesit tuaj. Me respekt për privatësinë, të shkallëzueshëm dhe të besueshëm.',
    },
    types: {
      title: 'Zgjidhje për biznesin tuaj',
      lead: 'Çdo sektor ka kërkesat e veta. I njohim sfidat tipike dhe planifikojmë në përputhje me to.',
      items: {
        '0': { title: 'Tregtia dhe dyqanet', desc: 'Hyrja, sipërfaqja e shitjes, arka dhe magazina – të mbikëqyrura me diskrecion dhe efektivitet. Mbrojtje nga vjedhja dhe vandalizmi.', tags: { '0': 'Brenda', '1': 'Mbrojtje nga vjedhja', '2': 'Arka' } },
        '1': { title: 'Zyrat dhe klinikat', desc: 'Recepsioni, korridoret, zonat e ndjeshme dhe parkingjet, me të drejta qasjeje dhe zona private.', tags: { '0': 'Brenda', '1': 'Recepsioni', '2': 'Privatësia' } },
        '2': { title: 'Magazina dhe logjistika', desc: 'Mbikëqyrje e sipërfaqeve të mëdha me kënd të gjerë dhe PTZ. Pamje e zonave të dorëzimit, rafteve dhe jashtë ditë e natë.', tags: { '0': 'Brenda', '1': 'Jashtë', '2': 'Shikim nate' } },
        '3': { title: 'Gastronomia', desc: 'Hyrja, banaku, hyrja e kuzhinës dhe jashtë – kamera të qëndrueshme për mjedise të lagështa dhe të nxehta.', tags: { '0': 'Brenda', '1': 'Jashtë', '2': 'E qëndrueshme' } },
        '4': { title: 'Punishtet dhe industria', desc: 'Mjediset më të vështira kërkojnë kamera veçanërisht të qëndrueshme. Punishte, zona të jashtme dhe platforma ngarkimi të mbrojtura.', tags: { '0': 'Brenda', '1': 'E qëndrueshme', '2': 'Shikim nate' } },
        '5': { title: 'Disa lokacione', desc: 'Qasje qendrore në të gjitha kamerat përmes një aplikacioni. Menaxhim përdoruesish me të drejta të diferencuara.', tags: { '0': 'Shumë-lokacione', '1': 'Qendrore', '2': 'Aplikacion' } },
      },
    },
    features: {
      title: 'Funksione për përdorim biznesi',
      lead: 'Instalimet tregtare kërkojnë më shumë se kamera. Konfigurojmë në mënyrë profesionale të drejtat, planet e regjistrimit dhe njoftimet.',
      items: {
        '0': { title: 'Menaxhimi i përdoruesve', desc: 'Të drejta të ndryshme qasjeje për punonjësit, menaxherët e degëve dhe drejtimin. Kush mund të shohë cilën kamerë?' },
        '1': { title: 'Regjistrimi dhe arkivimi', desc: 'Regjistrues lokal me ruajtje të dyfishtë. Kohëzgjatja sipas kërkesave operacionale e ligjore.' },
        '2': { title: 'Njoftimet e ngjarjeve', desc: 'Mesazhe push te lëvizjet, kalimi i vijës ose ngjarjet e përcaktuara, sipas sistemit.' },
        '3': { title: 'Zgjerueshmëria', desc: 'Biznesi juaj rritet? Sistemet ekzistuese zakonisht mund të zgjerohen me kamera dhe lokacione.' },
      },
    },
    legal: {
      eyebrow: 'Mbrojtja e të dhënave dhe ligji',
      title: 'Mbikëqyrje biznesi në përputhje me ligjin',
      lead: 'Për mbikëqyrjen tregtare vlejnë rregulla shtesë, veçanërisht për punonjësit, klientët dhe zonat publike. Ju mbështesim në zbatimin teknik të:',
      list: {
        '0': 'Transparencë dhe tabela në hyrje',
        '1': 'Maskim i dhomave të zhveshjes dhe pushimit',
        '2': 'Zbatim teknik i të drejtave të qasjes dhe përdoruesve',
        '3': 'Ruajtje lokale me afat të përcaktuar',
        '4': 'Dokumentim i nevojës operacionale',
      },
      note: 'Shënim: ligjshmëria e mbikëqyrjes së biznesit varet nga rasti. Ju këshillojmë teknikisht, pa zëvendësuar këshillën ligjore.',
    },
    cta: {
      title: 'Biznesi juaj meriton siguri profesionale',
      lead: 'Analizojmë proceset tuaja dhe planifikojmë një sistem që mbron pa penguar. Pa detyrim dhe në mënyrë transparente.',
      primary: 'Rezervoni një takim konsultimi',
      secondary: 'Zbuloni SSG Care',
    },
  },
};